const {registerModule} = window;

class ResourcePageLiveNav {
  constructor(element) {
    this.element = element;
    this.initialize();
  }

  bindEvents() {
    this.ui.$categoryNavigationItems.forEach((navItem) => {
      navItem.addEventListener('click', (e) => this.onFilterClick(e));
    });
    this.ui.$tagNavigationItems.forEach((navItem) => {
      navItem.addEventListener('click', (e) => this.onFilterClick(e));
    });
  }

  bindUI() {
    this.ui = {};
    this.ui.$categoryNavigationItems = this.element.querySelectorAll('[data-category]');
    this.ui.$tagNavigationItems = this.element.querySelectorAll('[data-tag]');
    this.ui.$postListsDefault = document.querySelectorAll('.post-list--non-filtered');
    this.ui.$postListFiltered = document.querySelector('.post-list--filtered-only');
    this.ui.$filteredHeader = this.ui.$postListFiltered.querySelector('.post-list-columns__title');

    this.ui.cards = this.ui.$postListFiltered.querySelectorAll('.post-list-columns__item');
    this.cardData = [...this.ui.cards].map((card) => {
      return {
        card: card,
        category: card.dataset.category || null,
        tags: card.dataset.tags ? new Set(card.dataset.tags.split(',')) : new Set(),
      };
    });
  }

  initialize() {
    this.bindUI();
    this.setVars();
    this.bindEvents();
    this.initializeNavBars();
    this.filterCards();
  }

  setVars() {
    const params = new URLSearchParams(location.search);
    this.category = params.get('category');
    this.tags = params.getAll('tag');
  }


  onFilterClick(e) {
    const target = e.target;
    e.preventDefault();
    const newURL = new URL(window.location.href);
    const params = new URLSearchParams(location.search);

    // category adjustment
    if (target.dataset.category) {
      if (target.dataset.category === 'all') {
        params.delete('category');
      } else {
        params.set('category', target.dataset.category);
      }
      this.ui.$categoryNavigationItems.forEach((categoryItem) => {
        categoryItem.parentNode.classList.remove('navigation__list-item--active');
      });
      target.parentNode.classList.add('navigation__list-item--active');
      this.category = params.get('category');
      this.categoryLabel = target.dataset.categoryLabel;
    }

    // tag adjustment
    if (target.dataset.tag) {
      const tags = params.getAll('tag');
      const tag = target.dataset.tag;
      const tagIndex = tags.indexOf(tag);

      // if tag was already present, we delete it
      if (tagIndex >= 0) {
        tags.splice(tagIndex, 1);
        params.delete('tag');
        tags.forEach((tag) => {
          params.append('tag', tag);
        });
        target.parentNode.classList.remove('secondaryNav__list-item--active');
        const labelIdx = this.tagLabels.indexOf(target.dataset.tagLabel);
        this.tagLabels.splice(labelIdx, 1);
      // if tag was not already present, we add it
      } else {
        tags.push(tag);
        params.append('tag', tag);
        target.parentNode.classList.add('secondaryNav__list-item--active');
        this.tagLabels.push(target.dataset.tagLabel);
      }

      this.tags = params.getAll('tag');
    }

    newURL.search = params;
    window.history.pushState({}, '', newURL.href);

    this.filterCards();
  }


  filterCards() {
    // this.category & this.tags are the values we're testing each card against
    // card.category & card.tags are the values associated with the individual cards
    this.cardData.forEach((cardItem) => {
      let show = true;
      if (this.category && (cardItem.category !== this.category)) {
        show = false;
      }
      if (this.tags?.length > 0 && show === true) {
        let matchedAny = false;
        this.tags.forEach((tag) => {
          if (cardItem.tags.has(tag)) {
            matchedAny = true;
          }
        });
        if (!matchedAny) {
          show = false;
        }
      }

      if (show) {
        cardItem.card.classList.remove('post-list__item--hidden');
      } else {
        cardItem.card.classList.add('post-list__item--hidden');
      }
    });

    if (this.category || this.tags?.length > 0) {
      this.ui.$postListFiltered.classList.remove('post-list--hidden');
      this.ui.$postListsDefault.forEach((list) => list.classList.add('post-list--hidden'));

      this.ui.$filteredHeader.innerText = this.buildHeader();
    } else {
      this.ui.$postListFiltered.classList.add('post-list--hidden');
      this.ui.$postListsDefault.forEach((list) => list.classList.remove('post-list--hidden'));
    }
  }

  buildHeader() {
    let header = 'All ';
    if (this.tagLabels.length > 2) {
      header += `'${this.tagLabels.slice(0, -1).join('\', \'')}', or '${this.tagLabels.slice(-1)}' `;
    } else if (this.tagLabels.length > 0) {
      header += `'${this.tagLabels.join('\' or \'')}' `;
    }

    header += this.category ? this.categoryLabel + 's' : 'Resources';
    return header;
  }

  initializeNavBars() {
    this.ui.$categoryNavigationItems.forEach((categoryItem) => {
      if ((categoryItem.dataset.category === 'all' && !this.category) || (categoryItem.dataset.category === this.category)) {
        this.categoryLabel = categoryItem.dataset.categoryLabel;
        categoryItem.parentNode.classList.add('navigation__list-item--active');
      } else {
        categoryItem.parentNode.classList.remove('navigation__list-item--active');
      }
    });

    this.tagLabels = [];
    this.ui.$tagNavigationItems.forEach((tagItem) => {
      if (this.tags.includes(tagItem.dataset.tag)) {
        this.tagLabels.push(tagItem.dataset.tagLabel);
        tagItem.parentNode.classList.add('secondaryNav__list-item--active');
      } else {
        tagItem.parentNode.classList.remove('secondaryNav__list-item--active');
      }
    });
  }
}

registerModule('ResourcePageLiveNav', ResourcePageLiveNav);
